<template>
  <div
    v-if="card"
    class="card"
  >
    <img
      class="wizard-icon"
      :src="src"
      :alt="`${authData.projectName} logo`"
    >
  </div>
  <img
    v-else
    class="wizard-icon"
    :src="src"
    :alt="`${authData.projectName} logo`"
  >
</template>

<script>
import { mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';

export default {
  name: 'WizardIcon',
  props: {
    src: { type: String, default: '' },
    card: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useAppAuthData, ['authData']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wizard-icon {
      position: absolute;
      top: -30px;
      left: calc(50% - 30px);
      z-index: 10;
      border-radius: 10px;
      max-height: 60px;
      max-width: 60px;
  }

.card {
  width: 90px;
  height: 90px;
  background: @white;
  position: absolute;
  border-radius: 10px;
  filter: drop-shadow(0px 4px 10px @grey-500);
  top: 60px;
  left: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .wizard-icon {
    position: inherit;
    top: auto;
    left: auto;
  }
}
</style>
